// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  unavailableDeliverables: {
    pointerEvents: 'none',

    '& h3': {
      color: 'lightgray',
    },
    '& h4': {
      color: 'lightgray',
    },
    '& p': {
      color: 'lightgray',
    },
    '& span': {
      color: 'lightgray',
    },
  },
  noDeliverableMessage: {
    marginBottom: '8px',
    marginTop: '8px',
    fontSize: 'small',
    fontWeight: 400,
    color: 'lightgray',
  },
  addons: {
    marginTop: '25px',
  },
  addonsHeading: {
    marginBottom: '16px',
    marginTop: '16px',
    textTransform: 'capitalize',
  },
  datasightSpanText: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  costPerAcre: {
    fontSize: '13px',
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '18px',
    cursor: 'pointer',
  },
});

export default styles;
